export default __webpack_public_path__ + "static/media/defautRadioButton.827956e2.svg";